import { getIcon } from "mt-components/Icons";
import { useState } from "react";
import type { ExtraInfoInclusion } from ".";
import ExtraInfoButton from "./ExtraInfoButton";
import ExtraInfoModal from "./ExtraInfoModal";
import modalStyles from "./ExtraInfoModal.module.scss";
import styles from "./WhatsIncludedButton.module.scss";

type WhatsIncludedButtonProps = {
  inclusions: ExtraInfoInclusion[] | null | undefined;
};

export default function WhatsIncludedButton({
  inclusions,
}: WhatsIncludedButtonProps) {
  const [open, setOpen] = useState(false);

  if (!inclusions) return <></>;

  const sortedInclusions = inclusions.sort((a, b) => a.index - b.index);

  return (
    <>
      <ExtraInfoButton label="What's included" onClick={() => setOpen(true)} />
      <ExtraInfoModal
        open={open}
        title="What's included"
        content={sortedInclusions.map((inclusion) => (
          <div className={modalStyles.item} key={inclusion.index}>
            <span className={styles.inclusionIcon}>
              {getIcon(inclusion.icon ?? "")}
            </span>
            <div>
              <p className={styles.itemTitle}>{inclusion.title}</p>
              {inclusion.description && (
                <p className={modalStyles.itemText}>
                  {inclusion.description}
                </p>
              )}
            </div>
          </div>
        ))}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
